import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=240ec4ae&scoped=true"
import script from "./blogDetail.vue?vue&type=script&lang=js"
export * from "./blogDetail.vue?vue&type=script&lang=js"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=240ec4ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240ec4ae",
  null
  
)

export default component.exports